var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 36,
    viewBox: "0 0 121 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.519 36H4.48148C2.01779 36 0 33.9739 0 31.5V4.5C0 2.02613 2.01779 3.33786e-06 4.48148 3.33786e-06H116.519C118.982 3.33786e-06 121 2.02613 121 4.5V31.5C121 33.9739 118.982 36 116.519 36Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.519 0.721127C118.593 0.721127 120.282 2.4165 120.282 4.5V31.5C120.282 33.5835 118.593 35.2789 116.519 35.2789H4.48148C2.40656 35.2789 0.718157 33.5835 0.718157 31.5V4.5C0.718157 2.4165 2.40656 0.721127 4.48148 0.721127H116.519ZM116.519 3.33786e-06H4.48148C2.01779 3.33786e-06 0 2.02613 0 4.5V31.5C0 33.9739 2.01779 36 4.48148 36H116.519C118.982 36 121 33.9739 121 31.5V4.5C121 2.02613 118.982 3.33786e-06 116.519 3.33786e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35285 6.78489C9.08956 7.06165 8.93719 7.49252 8.93719 8.05052V27.954C8.93719 28.512 9.08956 28.9429 9.35285 29.2196L9.41783 29.2804L20.5252 18.1316V17.8684L9.41783 6.71965L9.35285 6.78489Z",
    fill: "url(#paint0_linear_1619_751)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2235 21.8497L20.5251 18.1316V17.8684L24.228 14.1502L24.3109 14.1986L28.696 16.704C29.9475 17.415 29.9475 18.585 28.696 19.3005L24.3109 21.8014L24.2235 21.8497Z",
    fill: "url(#paint1_linear_1619_751)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3109 21.8014L20.5252 18L9.35284 29.2196C9.7685 29.6584 10.4463 29.7112 11.2171 29.2725L24.3109 21.8014Z",
    fill: "url(#paint2_linear_1619_751)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3109 14.1986L11.2171 6.7275C10.4463 6.29325 9.7685 6.34613 9.35284 6.78488L20.5252 18L24.3109 14.1986Z",
    fill: "url(#paint3_linear_1619_751)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5001 9.21946C42.5001 9.97096 42.2761 10.5728 41.8346 11.0217C41.3271 11.5538 40.6661 11.8216 39.8561 11.8216C39.0819 11.8216 38.4209 11.5493 37.8786 11.0127C37.3352 10.4682 37.0641 9.79996 37.0641 9.00009C37.0641 8.20021 37.3352 7.53196 37.8786 6.99196C38.4209 6.45084 39.0819 6.17859 39.8561 6.17859C40.2415 6.17859 40.6089 6.25846 40.9596 6.40696C41.3092 6.55659 41.5937 6.75909 41.7999 7.00884L41.3316 7.48359C40.9719 7.05721 40.4823 6.84684 39.8561 6.84684C39.2914 6.84684 38.8018 7.04484 38.3861 7.44421C37.9749 7.84471 37.7688 8.36334 37.7688 9.00009C37.7688 9.63684 37.9749 10.16 38.3861 10.5605C38.8018 10.9553 39.2914 11.1578 39.8561 11.1578C40.4555 11.1578 40.9596 10.9553 41.3573 10.556C41.6195 10.2916 41.7685 9.92709 41.8077 9.46134H39.8561V8.81109H42.4598C42.4912 8.95171 42.5001 9.08784 42.5001 9.21946Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6309 6.96487H44.1852V8.67487H46.39V9.32512H44.1852V11.0351H46.6309V11.6977H43.4928V6.30225H46.6309V6.96487Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5461 11.6977H48.8537V6.96487H47.3535V6.30225H51.0474V6.96487H49.5461V11.6977Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7206 11.6977V6.30225H54.4119V11.6977H53.7206Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4761 11.6977H56.7893V6.96487H55.2835V6.30225H58.9819V6.96487H57.4761V11.6977Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9752 11.0037C65.4453 11.5493 64.7888 11.8216 64.0056 11.8216C63.218 11.8216 62.5615 11.5493 62.0315 11.0037C61.5027 10.4592 61.2394 9.79096 61.2394 9.00009C61.2394 8.20921 61.5027 7.54096 62.0315 6.99646C62.5615 6.45084 63.218 6.17859 64.0056 6.17859C64.7843 6.17859 65.4408 6.45084 65.9708 7.00096C66.5041 7.54996 66.7674 8.21371 66.7674 9.00009C66.7674 9.79096 66.5041 10.4592 65.9752 11.0037ZM62.5436 10.5515C62.9424 10.9553 63.4275 11.1578 64.0056 11.1578C64.5793 11.1578 65.0689 10.9553 65.4632 10.5515C65.861 10.1476 66.0626 9.62896 66.0626 9.00009C66.0626 8.37121 65.861 7.85259 65.4632 7.44871C65.0689 7.04484 64.5793 6.84234 64.0056 6.84234C63.4275 6.84234 62.9424 7.04484 62.5436 7.44871C62.1458 7.85259 61.9442 8.37121 61.9442 9.00009C61.9442 9.62896 62.1458 10.1476 62.5436 10.5515Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7387 11.6977V6.30225H68.579L71.1917 10.4985H71.2219L71.1917 9.46124V6.30225H71.883V11.6977H71.1614L68.4255 7.2945H68.3952L68.4255 8.33624V11.6977H67.7387Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0691 19.5773C58.964 19.5773 57.2442 21.1861 57.2442 23.4057C57.2442 25.6073 58.964 27.2329 61.0691 27.2329C63.1788 27.2329 64.8986 25.6073 64.8986 23.4057C64.8986 21.1861 63.1788 19.5773 61.0691 19.5773ZM61.0691 25.7254C59.914 25.7254 58.9203 24.7681 58.9203 23.4057C58.9203 22.0253 59.914 21.0848 61.0691 21.0848C62.2242 21.0848 63.2225 22.0253 63.2225 23.4057C63.2225 24.7681 62.2242 25.7254 61.0691 25.7254ZM52.7235 19.5773C50.6138 19.5773 48.8986 21.1861 48.8986 23.4057C48.8986 25.6073 50.6138 27.2329 52.7235 27.2329C54.832 27.2329 56.5484 25.6073 56.5484 23.4057C56.5484 21.1861 54.832 19.5773 52.7235 19.5773ZM52.7235 25.7254C51.5673 25.7254 50.5702 24.7681 50.5702 23.4057C50.5702 22.0253 51.5673 21.0848 52.7235 21.0848C53.8786 21.0848 54.8724 22.0253 54.8724 23.4057C54.8724 24.7681 53.8786 25.7254 52.7235 25.7254ZM42.7925 20.7507V22.3774H46.6612C46.548 23.2864 46.2455 23.9547 45.7817 24.4204C45.217 24.9829 44.3375 25.6073 42.7925 25.6073C40.4118 25.6073 38.5475 23.6779 38.5475 21.2873C38.5475 18.8967 40.4118 16.9673 42.7925 16.9673C44.0798 16.9673 45.0165 17.4724 45.7077 18.1272L46.8494 16.9808C45.8825 16.0538 44.5963 15.3417 42.7925 15.3417C39.5278 15.3417 36.784 18.0091 36.784 21.2873C36.784 24.5656 39.5278 27.2329 42.7925 27.2329C44.5571 27.2329 45.8825 26.6524 46.9245 25.5634C47.9922 24.4913 48.3249 22.9838 48.3249 21.7666C48.3249 21.3886 48.2936 21.0409 48.2375 20.7507H42.7925ZM83.4015 22.0118C83.0867 21.1557 82.1153 19.5773 80.1367 19.5773C78.1761 19.5773 76.5437 21.1287 76.5437 23.4057C76.5437 25.5499 78.1593 27.2329 80.3249 27.2329C82.0761 27.2329 83.0866 26.1608 83.5023 25.5364L82.2027 24.6668C81.7691 25.3036 81.1787 25.7254 80.3249 25.7254C79.4768 25.7254 78.8685 25.3351 78.4786 24.5656L83.5774 22.4472L83.4015 22.0118ZM78.203 23.2864C78.1593 21.8104 79.3446 21.0544 80.1939 21.0544C80.8594 21.0544 81.424 21.3886 81.6122 21.8667L78.203 23.2864ZM74.0587 27.0001H75.7348V15.7501H74.0587V27.0001ZM71.3138 20.4301H71.2578C70.8813 19.9823 70.1632 19.5773 69.2534 19.5773C67.3443 19.5773 65.5988 21.2603 65.5988 23.4181C65.5988 25.5634 67.3443 27.2329 69.2534 27.2329C70.1632 27.2329 70.8813 26.8246 71.2578 26.3633H71.3138V26.9123C71.3138 28.3759 70.5351 29.1623 69.2792 29.1623C68.2552 29.1623 67.6199 28.4198 67.3578 27.7954L65.9002 28.4063C66.3203 29.421 67.4328 30.6698 69.2792 30.6698C71.2443 30.6698 72.9025 29.5088 72.9025 26.6839V19.8102H71.3138V20.4301ZM69.3969 25.7254C68.2417 25.7254 67.2749 24.7546 67.2749 23.4181C67.2749 22.0692 68.2417 21.0848 69.3969 21.0848C70.5351 21.0848 71.4326 22.0692 71.4326 23.4181C71.4326 24.7546 70.5351 25.7254 69.3969 25.7254ZM91.2485 15.7501H87.2399V27.0001H88.9115V22.7374H91.2485C93.105 22.7374 94.9256 21.3886 94.9256 19.2432C94.9256 17.0989 93.1005 15.7501 91.2485 15.7501ZM91.2922 21.1726H88.9115V17.3149H91.2922C92.5403 17.3149 93.2529 18.3556 93.2529 19.2432C93.2529 20.1139 92.5403 21.1726 91.2922 21.1726ZM101.625 19.5559C100.418 19.5559 99.1617 20.0914 98.6452 21.2783L100.129 21.9027C100.448 21.2783 101.035 21.0758 101.656 21.0758C102.523 21.0758 103.402 21.5989 103.416 22.5226V22.6407C103.113 22.4652 102.466 22.2053 101.669 22.2053C100.071 22.2053 98.4436 23.0884 98.4436 24.7366C98.4436 26.2441 99.7522 27.2149 101.223 27.2149C102.348 27.2149 102.969 26.7053 103.359 26.1124H103.416V26.982H105.03V22.6666C105.03 20.6719 103.547 19.5559 101.625 19.5559ZM101.424 25.7209C100.877 25.7209 100.115 25.4487 100.115 24.7681C100.115 23.8973 101.065 23.5632 101.888 23.5632C102.624 23.5632 102.969 23.7263 103.416 23.9412C103.285 24.9829 102.392 25.7209 101.424 25.7209ZM110.912 19.8023L108.991 24.6792H108.934L106.947 19.8023H105.144L108.129 26.6176L106.426 30.4099H108.173L112.772 19.8023H110.912ZM95.8443 27.0001H97.5204V15.7501H95.8443V27.0001Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1619_751",
    x1: 19.539,
    y1: 28.1613,
    x2: 4.43495,
    y2: 13.1194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1619_751",
    x1: 30.3256,
    y1: 17.9987,
    x2: 8.63802,
    y2: 17.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1619_751",
    x1: 22.2523,
    y1: 15.9335,
    x2: 1.77004,
    y2: -4.46452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1619_751",
    x1: 6.54054,
    y1: 35.8414,
    x2: 15.6868,
    y2: 26.7329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.75103d235131d8c063574c62822b98fd.svg";
export { ForwardRef as ReactComponent };